import React, { useState } from 'react';

const HeroBanner = () => {
  const [videoError, setVideoError] = useState(false);

  const handleVideoError = () => {
    setVideoError(true);
  };

  return (
    <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 -z-20">
        {!videoError ? (
          <video
            className="w-full h-full object-cover object-center"
            autoPlay
            muted
            loop
            playsInline
            onError={handleVideoError}
          >
            <source 
              src="./admin/api/wp-content/uploads/2024/04/WhatsApp-Video-2024-04-01-at-9.09.58-AM.mp4" 
              type="video/mp4" 
            />
          </video>
        ) : (
          <img
            src="assets/hero-banner.jpg"
            alt="PAK School & College Hero Banner"
            className="w-full h-full object-cover object-center"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/80"></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-4 animate-fade-in">
            <span className="text-xs sm:text-sm font-medium text-white">🌟 Excellence in Education Since 1998</span>
          </div>
          
          {/* Main Title */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-3 sm:mb-4 leading-tight animate-fade-in-up">
            Welcome to{' '}
            <span className="text-red-500 drop-shadow-lg">PAK School & College</span>
          </h1>
          
          {/* Subtitle */}
          <p className="text-lg sm:text-xl md:text-2xl font-semibold text-white/90 mb-4 sm:mb-6 animate-fade-in-up animation-delay-200">
            Every Student A Star
          </p>
          
          {/* Description */}
          <p className="text-sm sm:text-base md:text-lg text-white/80 mb-6 sm:mb-8 max-w-xl leading-relaxed animate-fade-in-up animation-delay-400">
            Nurturing academic excellence, building character, and shaping future leaders through 
            innovative teaching and a comprehensive curriculum.
          </p>
          
          {/* Stats */}
          <div className="flex flex-wrap gap-4 sm:gap-6 mb-6 sm:mb-8 animate-fade-in-up animation-delay-600">
            <div className="text-center">
              <div className="text-2xl sm:text-3xl font-bold text-white">27+</div>
              <div className="text-xs sm:text-sm text-white/70">Years</div>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl font-bold text-white">1600+</div>
              <div className="text-xs sm:text-sm text-white/70">Students</div>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl font-bold text-white">3</div>
              <div className="text-xs sm:text-sm text-white/70">Campuses</div>
            </div>
          </div>
          
          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 animate-fade-in-up animation-delay-800">
            <a 
              href="#about" 
              className="inline-flex items-center justify-center px-4 py-2 sm:px-6 sm:py-3 bg-red-600 hover:bg-red-700 text-white text-sm sm:text-base font-semibold rounded-full transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg hover:shadow-red-500/25 group"
            >
              <span>Discover More</span>
              <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>
            <a 
              href="/admission" 
              className="inline-flex items-center justify-center px-4 py-2 sm:px-6 sm:py-3 bg-white/10 hover:bg-white/20 text-white text-sm sm:text-base font-semibold rounded-full border border-white/30 hover:border-white/50 transition-all duration-300 transform hover:-translate-y-1 backdrop-blur-sm group"
            >
              <span>Apply Now</span>
              <svg className="w-4 h-4 ml-2 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-fade-in-up animation-delay-1000">
        <div className="flex flex-col items-center cursor-pointer group">
          <div className="w-1 h-5 bg-white/60 rounded-full mb-1 group-hover:bg-white/80 transition-colors"></div>
          <div className="w-1 h-5 bg-white/40 rounded-full mb-1 group-hover:bg-white/60 transition-colors"></div>
          <div className="w-1 h-5 bg-white/20 rounded-full group-hover:bg-white/40 transition-colors"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
